import { Button, Col, Row } from 'antd';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import { downloadApplications, handleDownload } from '../../common/Utilities';
import { API } from '../../common/Constants';

const CaseSumary = ({ pdfurl }) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-hidden">
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>Case Summary</p>
                        </div>
                    </Col>
                </Row >
            </div >
            <div className='min-[768px]:mx-[50px]'>
                <iframe src={`${API.BaseUrl}application/summary/` + localStorage.getItem('applicationId')} className='h-[900px]' id='pdf' title="PDF Viewer" width="100%" />
            </div>
            <div className="bg-white text-center p-[18px_25px]" >
                <Row justify="center" align="middle">
                    <Col>
                        <Button onClick={() => {
                            downloadApplications();
                        }} className='mr-3' type="primary">Download All Relevant Documents</Button>
                    </Col>
                    <Col>
                        <Button onClick={()=>{handleDownload(`${API.BaseUrl}application/summary/` + localStorage.getItem('applicationId'))}} className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px]' type="default">Download Summary Only</Button>
                    </Col>
                </Row>
            </div >
        </div >
    );
};

export default CaseSumary;